import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '@shared/shared.module';
import { DynamicDirectiveModule } from '../../../directive/dynamic-directive.module';
import { DynamicPipeModule } from '../../../pipe/dynamic-pipe.module';
import { DynamicRenderSharedModule } from '../../shared/shared.module';
import { BuildingBlockSharedModule } from '../shared/shared.module';
import { AlertFieldComponent } from './alert/alert.component';
import { BulletedListComponent } from './bulleted-list/bulleted-list.component';
import { ButtonComponent } from './button/button.component';
import { CheckboxGroupComponent } from './checkbox-group/checkbox-group.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { ContentComponent } from './content/content.component';
import { DropdownComponent } from './dropdown/dropdown.component';
import { FieldGroupComponent } from './field-group/field-group.component';
import { InfoRowObfuscateComponent } from './info-row-obfuscate/info-row-obfuscate.component';
import { InfoRowComponent } from './info-row/info-row.component';
import { InputMaskComponent } from './input-mask/input-mask.component';
import { InputObfuscateComponent } from './input-obfuscate/input-obfuscate.component';
import { InputComponent } from './input/input.component';
import { RadioComponent } from './radio/radio.component';
import { SelectionGridComponent } from './selection-grid/selection-grid.component';
import { TextareaComponent } from './textarea/textarea.component';
import { ToggleComponent } from './toggle/toggle.component';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';

const components = [
  AlertFieldComponent,
  BulletedListComponent,
  ButtonComponent,
  CheckboxComponent,
  CheckboxGroupComponent,
  ContentComponent,
  DropdownComponent,
  FieldGroupComponent,
  InfoRowComponent,
  InfoRowObfuscateComponent,
  InputComponent,
  InputObfuscateComponent,
  InputMaskComponent,
  RadioComponent,
  SelectionGridComponent,
  TextareaComponent,
  ToggleComponent
];

@NgModule({
  declarations: [...components],
  exports: [...components],
  imports: [
    CommonModule,
    DynamicRenderSharedModule,
    FormsModule,
    NgxMaskDirective,
    NgxMaskPipe,
    BuildingBlockSharedModule,
    DynamicPipeModule,
    DynamicDirectiveModule,
    SharedModule
  ],
  providers: [provideNgxMask()]
})
export class ControlsModule {}
